import { Sprite } from "pixi.js"
import { CHAR_HEIGHT, CHAR_WIDTH, SCALE_FACTOR } from "./config"
import { getTexture } from "./spritesheet"

export type CharDisplayChar = "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | ":"

export default class CharDisplay extends Sprite {
  static DIGIT_WIDTH = CHAR_WIDTH * SCALE_FACTOR
  static DIGIT_HEIGHT = CHAR_HEIGHT * SCALE_FACTOR

  private _char: CharDisplayChar

  get char() {
    return this._char
  }
  set char(value: CharDisplayChar) {
    this._char = value
    this.texture = getTexture(`char${value}`)
  }

  constructor(params: { x: number, y: number, char: CharDisplayChar }) {
    super({
      x: params.x,
      y: params.y,
      width: CharDisplay.DIGIT_WIDTH,
      height: CharDisplay.DIGIT_HEIGHT,
      texture: getTexture(`char${params.char}`)
    })

    this._char = params.char
  }
}
